/** @format */

import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const modernColors = ["#06B6D4", "#F59E0B"];
const hoverColors = ["#0891B2", "#D97706"];

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "right",
      labels: {
        color: "#2C3E50",
        font: {
          size: 14,
          weight: "bold",
        },
      },
    },
    datalabels: {
      formatter: (value) => `${value}%`,
      color: "#fff",
      backgroundColor: "rgba(44, 62, 80, 0.8)",
      borderRadius: 4,
      padding: 6,
      font: {
        weight: "bold",
        size: 14,
      },
    },
  },
};

const PieChart1 = ({ d1, d2, f1, f2 }) => {
  const data = {
    labels: [`O’zbekiston - ${d1} m³/s`, `Qirg’iziston - ${d2} m³/s`],
    datasets: [
      {
        label: "Suv taqsimoti",
        data: [f1, f2],
        backgroundColor: modernColors,
        hoverBackgroundColor: hoverColors,
        borderColor: "#ECF0F1",
        borderWidth: 2,
        hoverBorderColor: "#BDC3C7",
      },
    ],
  };

  return (
    <div
      className='pie-box'
      style={{
        height: "450px",
      }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default PieChart1;
